<template>
  <div>
    <h2 class="mb-4">จัดการไฟล์เสียงหนังสือ</h2>
    <CRow>
      <CCol md="3">
        <CInput
          v-model="word"
          placeholder="ค้นหา"
          @keyup.enter="handleSearch"
        />
      </CCol>
      <CCol md="3">
        <CSelect :value.sync="filterSelected" :options="filter" />
      </CCol>
      <CCol md="3">
        <CSelect
          :options="[
            'แสดงทั้งหมด',
            'แสดงเฉพาะหนังสือที่ Export แล้ว',
            'แสดงเฉพาะหนังสือที่ยังไม่ Export',
            'แสดงหนังสือที่ ดาวโหลด แล้ว',
            'แสดงหนังสือที่ ยังไม่ดาวโหลด'
          ]"
        />
      </CCol>
      <CCol md="3">
        <div class="flex space-between mb-3">
          <CButton color="primary" @click="handleSearch"
            ><i class="fas fa-search"></i> ค้นหา
          </CButton>
          <vue-excel-xlsx
            :data="rows"
            :columns="columns"
            :filename="'filename'"
            :sheetname="'sheetname'"
          >
            <CButton color="info">
              <i class="far fa-file-excel"></i> Excel download
            </CButton>
          </vue-excel-xlsx>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-good-table
          :columns="article.columns"
          :rows="article.rows"
          :select-options="{ enabled: true, disableSelectInfo: true }"
          ref="table"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'action'">
              <CButton
                color="primary"
                size="sm"
                title="คลิกที่นี่เพื่อดาวโหลด"
                class="m-1"
              >
                <CIcon name="cil-cloud-download" />
              </CButton>
              <CButton
                color="info"
                size="sm"
                title="ปุ่ม Export Daisy"
                class="m-1"
              >
                <CIcon name="cib-soundcloud" />
              </CButton>
            </span>
            <span v-else class="h6">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </CCol>
      <CCol col="12">
        <CButton
          color="primary"
          size="sm"
          title="ปุ่มดาวโหลดลิ้งทั้งหมดที่เลือก"
          class="mr-1 mt-2"
          @click="downloadSelectedItem()"
        >
          <CIcon name="cil-cloud-download" />
        </CButton>
        <CButton
          color="info"
          size="sm"
          title="ปุ่มแปลงเป็น Daisy ทั้งหมด"
          class="mr-1 mt-2"
          @click="convertSelectedItem()"
        >
          <CIcon name="cib-soundcloud" />
        </CButton>
        <CButton
          color="danger"
          size="sm"
          title="ปุ่มลบหนังสือที่เลือก"
          class="mr-1 mt-2"
          @click="$refs.deleteModal.show()"
        >
          <CIcon name="cil-trash" />
        </CButton>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-ads-pagination
          :total-items="article.rows.length"
          :max-visible-pages="5"
          :items-per-page="5"
          :page="search.page"
          :loading="loading"
        >
          <template slot-scope="props">
            <div class="vue-ads-pr-2 vue-ads-leading-loose">
              รายการที่ {{ props.start | decimalFormat }} ถึง
              {{ props.end | decimalFormat }} จาก
              {{ props.total | decimalFormat }} รายการ
            </div>
          </template>
          <template slot="buttons" slot-scope="props">
            <vue-ads-page-button
              v-for="(button, key) in props.buttons"
              :key="key"
              v-bind="button"
              @page-change="pageChange(button.page)"
            />
          </template>
        </vue-ads-pagination>
      </CCol>
    </CRow>

    <DeleteModal ref="deleteModal" :onConfirm="deleteSelectedItem" />
  </div>
</template>

<script>
import DeleteModal from '../modal/DeleteModal'

export default {
  name: 'Rfb3',
  components: {
    DeleteModal
  },
  data() {
    return {
      loading: false,
      search: {},
      defaultSearch: {
        page: 0,
        limit: 10,
        name: '',
        sort: {
          field: 'name',
          type: 'asc'
        }
      },
      article: {
        columns: [
          {
            label: 'ชื่อหนังสือ',
            field: 'name'
          },
          {
            label: 'ผู้แปล',
            field: 'translator'
          },
          {
            label: 'จำนวนบท',
            field: 'chapterCount',
            type: 'number'
          },
          {
            label: 'หมวดหมู่หนังสือ',
            field: 'category'
          },
          {
            label: 'ความสมบูรณ์',
            field: 'completion',
            type: 'percentage'
          },
          {
            label: 'สถานะ Export',
            field: 'exportStatus'
          },
          {
            label: 'วันที่ Export',
            field: 'exportAt',
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
            dateOutputFormat: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            label: 'วันที่สร้างหนังสือ',
            field: 'createdAt',
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
            dateOutputFormat: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            field: 'action',
            sortable: false,
            tdClass: 'text-center'
          }
        ],
        rows: []
      }
    }
  },
  methods: {
    handleSearch() {
      this.search = Object.assign({}, this.defaultSearch)
      if (this.word) this.search[this.filterSelected] = this.word

      this.getList()
    },
    pageChange(page) {
      this.search.page = page
      this.getList()
    },
    onSortChange(params) {
      this.search.sort = params[0]
      this.getList()
    },
    getList() {
      // this.loading = true
      // apiArticle
      //   .getList(this.search)
      //   .then((result) => {
      //     this.total = result.data.totalDocs
      //     this.article.rows = []
      //     for (let i = 0; i < result.data.docs.length; i++) {
      //       const item = result.data.docs[i]
      //       this.article.rows.push({
      //         no: this.search.page * this.search.limit + i + 1,
      //         id: item.id,
      //         name: item.name,
      //         author: item.author.name,
      //         translator: item.translatorName,
      //         // publisher: --> no in response,
      //         category: item.category.name,
      //         // createdAt: --> no in response
      //         // chapterCount: --> no in response
      //         // pageCount: --> no in response
      //         // completion: --> no in response
      //         // isShare: --> no in response
      //         // coverImage: --> no in response
      //         detail: item.detail,
      //         // reader: --> shouldn't be in bookChapter object
      //         sound: [] // --> bookChapter must be array
      //       })
      //     }
      //   })
      //   .catch(() => {
      //     this.article.rows = []
      //     this.loading = false
      //   })
    },
    downloadSelectedItem() {
      //TODO : call API
      this.$refs['table'].selectedRows.map((item) => {
      })
    },
    convertSelectedItem() {
      //TODO : call API
      this.$refs['table'].selectedRows.map((item) => {
      })
    },
    deleteSelectedItem() {
      //TODO : call API
      this.$refs['table'].selectedRows.map((item) => {
      })
    }
  }
}
</script>
